module.exports = __webpack_public_path__ + "static/media/Gotham-Ultra.2f974201.ttf";